import { NativeModule } from "./PersistentKeyboardModule.web.ts";
import type { ChangeTextEvent, KeyPressEvent } from "./PersistentKeyboard.types.ts";

type ListenerSubscription = { remove(): void };

export function focus(): void {
  NativeModule.focus();
}

export function blur(): void {
  NativeModule.blur();
}

export function setText(text: string): void {
  // The web stub advances its own counter and broadcasts the change (including the assigned
  // `eventCount`) to `onChangeText` subscribers itself, so there is no JS-side mirror here.
  NativeModule.setText(text);
}

export function restoreText(text: string, expectedEventCount: number): void {
  NativeModule.restoreText(text, expectedEventCount);
}

export async function preserveFocus(): Promise<void> {
  return NativeModule.preserveFocus();
}

export function onChangeText(listener: (event: ChangeTextEvent) => void): ListenerSubscription {
  return NativeModule.addListener("onChangeText", listener);
}

export function onKeyPress(listener: (event: KeyPressEvent) => void): ListenerSubscription {
  return NativeModule.addListener("onKeyPress", listener);
}

export { default as PersistentKeyboardView } from "./PersistentKeyboardView.web.tsx";
export type { ChangeTextEvent, KeyPressEvent } from "./PersistentKeyboard.types.ts";
export { PERSISTENT_KEYBOARD_TOOLBAR_PORTAL_HOST_NAME } from "./persistent-keyboard-toolbar-portal-host-name.ts";
export type { PersistentKeyboardViewProps } from "./PersistentKeyboard.types.ts";

export { registerTextTransformer } from "./PersistentKeyboardModule.web.ts";
